// extracted by mini-css-extract-plugin
module.exports = {"root":"_2D1PA","logo":"ug5uY"};